import styled from "styled-components";

const HeaderContainer = styled.div`
  border-bottom: 1px solid #E1E4EA;
  margin-bottom: 24px;
  padding-bottom: 24px;
`;

export default HeaderContainer;